module.exports = __webpack_public_path__ + "img/242.d6ff54bf.jpg";